
import Navbar from '../visa-travel-tips/components/Navbar';
import Footer from '../visa-travel-tips/components/Footer';

export default function FamilyTravelTips() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-pink-500 to-red-500 text-white py-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Lưu ý khi đi cùng trẻ em & người già
            </h1>
            <p className="text-xl text-pink-100 mb-8 max-w-3xl mx-auto">
              Hướng dẫn toàn diện cho chuyến du lịch gia đình an toàn và vui vẻ
            </p>
          </div>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <a href="/" className="hover:text-teal-600 transition-colors">Trang chủ</a>
            <span>/</span>
            <a href="/visa-travel-tips" className="hover:text-teal-600 transition-colors">Kinh nghiệm du lịch</a>
            <span>/</span>
            <span className="text-gray-900 font-medium">Du lịch gia đình</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <article className="prose prose-lg max-w-none">
          {/* Du lịch với trẻ em */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 flex items-center gap-3">
              <i className="ri-bear-smile-line text-pink-600"></i>
              Du lịch cùng trẻ em (0-12 tuổi)
            </h2>

            {/* Theo độ tuổi */}
            <div className="grid md:grid-cols-3 gap-6 mb-8">
              <div className="bg-blue-50 rounded-xl p-6">
                <h3 className="text-lg font-bold text-blue-900 mb-4 flex items-center gap-2">
                  <i className="ri-baby-line"></i>
                  Em bé (0-2 tuổi)
                </h3>
                <div className="space-y-4">
                  <div>
                    <h4 className="font-medium text-blue-800 mb-2">✈️ Trên máy bay:</h4>
                    <ul className="text-sm space-y-1">
                      <li>• Miễn phí vé nếu ngồi lòng</li>
                      <li>• Bassinet cho bay dài</li>
                      <li>• Cho bú khi cất/hạ cánh</li>
                      <li>• Mang milk formula dự phòng</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="font-medium text-blue-800 mb-2">🍼 Đồ dùng cần thiết:</h4>
                    <ul className="text-sm space-y-1">
                      <li>• Diapers (gấp 3 lần dự kiến)</li>
                      <li>• Baby food & formula</li>
                      <li>• Stroller du lịch</li>
                      <li>• Baby carrier</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-green-50 rounded-xl p-6">
                <h3 className="text-lg font-bold text-green-900 mb-4 flex items-center gap-2">
                  <i className="ri-child-line"></i>
                  Trẻ nhỏ (3-7 tuổi)
                </h3>
                <div className="space-y-4">
                  <div>
                    <h4 className="font-medium text-green-800 mb-2">🎮 Giải trí:</h4>
                    <ul className="text-sm space-y-1">
                      <li>• Tablet với games/movies</li>
                      <li>• Coloring books</li>
                      <li>• Small toys</li>
                      <li>• Snacks healthy</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="font-medium text-green-800 mb-2">🛡️ An toàn:</h4>
                    <ul className="text-sm space-y-1">
                      <li>• ID bracelet với thông tin</li>
                      <li>• Bright colored clothing</li>
                      <li>• Never leave alone</li>
                      <li>• Teach stranger danger</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-yellow-50 rounded-xl p-6">
                <h3 className="text-lg font-bold text-yellow-900 mb-4 flex items-center gap-2">
                  <i className="ri-user-smile-line"></i>
                  Trẻ lớn (8-12 tuổi)
                </h3>
                <div className="space-y-4">
                  <div>
                    <h4 className="font-medium text-yellow-800 mb-2">🎯 Hoạt động:</h4>
                    <ul className="text-sm space-y-1">
                      <li>• Tham gia planning</li>
                      <li>• Chụp ảnh riêng</li>
                      <li>• Educational activities</li>
                      <li>• Responsible tasks</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="font-medium text-yellow-800 mb-2">📱 Technology:</h4>
                    <ul className="text-sm space-y-1">
                      <li>• Own phone with GPS</li>
                      <li>• Emergency contacts</li>
                      <li>• Educational apps</li>
                      <li>• Photo challenges</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Chuẩn bị cho trẻ em */}
            <div className="bg-gradient-to-r from-pink-50 to-red-50 rounded-xl p-8 mb-8">
              <h3 className="text-xl font-bold text-pink-900 mb-6">🎒 Checklist cho trẻ em</h3>
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h4 className="font-semibold text-pink-800 mb-4">📋 Giấy tờ & Y tế</h4>
                  <ul className="space-y-2 text-sm">
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-pink-600 mt-1"></i>
                      <div>
                        <strong>Hộ chiếu riêng:</strong> Bắt buộc cho mọi lứa tuổi
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-pink-600 mt-1"></i>
                      <div>
                        <strong>Giấy khai sinh:</strong> Bản dịch công chứng
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-pink-600 mt-1"></i>
                      <div>
                        <strong>Consent letter:</strong> Nếu 1 bố/mẹ không đi
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-pink-600 mt-1"></i>
                      <div>
                        <strong>Vaccination record:</strong> Sổ tiêm chủng
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-pink-600 mt-1"></i>
                      <div>
                        <strong>Medical records:</strong> Bệnh lý đặc biệt
                      </div>
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-pink-800 mb-4">🧳 Đồ dùng thiết yếu</h4>
                  <ul className="space-y-2 text-sm">
                    <li className="flex items-start gap-2">
                      <i className="ri-heart-line text-pink-600 mt-1"></i>
                      <div>
                        <strong>Comfort items:</strong> Gấu bông, chăn yêu thích
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-shirt-line text-pink-600 mt-1"></i>
                      <div>
                        <strong>Extra clothes:</strong> Gấp đôi người lớn
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-medicine-bottle-line text-pink-600 mt-1"></i>
                      <div>
                        <strong>First aid kid:</strong> Thermometer, band-aids
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-gamepad-line text-pink-600 mt-1"></i>
                      <div>
                        <strong>Entertainment:</strong> Games, books, toys
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-restaurant-line text-pink-600 mt-1"></i>
                      <div>
                        <strong>Snacks:</strong> Healthy options they like
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Tips quan trọng */}
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-blue-50 rounded-lg p-6">
                <h4 className="font-semibold text-blue-900 mb-4">💡 Mẹo du lịch với trẻ</h4>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Plan flexibility:</strong> 50% thời gian dự phòng</li>
                  <li>• <strong>Nap time:</strong> Respect sleep schedule</li>
                  <li>• <strong>Kid-friendly hotels:</strong> Pool, family rooms</li>
                  <li>• <strong>Restaurant choice:</strong> Fast service, kids menu</li>
                  <li>• <strong>Emergency plan:</strong> Hospital locations</li>
                </ul>
              </div>
              
              <div className="bg-orange-50 rounded-lg p-6">
                <h4 className="font-semibold text-orange-900 mb-4">⚠️ Lưu ý an toàn</h4>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Never alone:</strong> Luôn có người lớn kèm</li>
                  <li>• <strong>ID information:</strong> Name, hotel, phone number</li>
                  <li>• <strong>Meeting point:</strong> Chỗ hẹn nếu lạc</li>
                  <li>• <strong>Photo daily:</strong> Chụp ảnh outfit mỗi ngày</li>
                  <li>• <strong>Local emergency:</strong> 911 & hospital info</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Du lịch với người già */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 flex items-center gap-3">
              <i className="ri-parent-line text-purple-600"></i>
              Du lịch cùng người cao tuổi (65+)
            </h2>

            <div className="bg-gradient-to-r from-purple-50 to-indigo-50 rounded-xl p-8 mb-8">
              <h3 className="text-xl font-bold text-purple-900 mb-6">🏥 Chuẩn bị y tế</h3>
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h4 className="font-semibold text-purple-800 mb-4">💊 Thuốc men & Hồ sơ</h4>
                  <ul className="space-y-2 text-sm">
                    <li className="flex items-start gap-2">
                      <i className="ri-medicine-bottle-fill text-purple-600 mt-1"></i>
                      <div>
                        <strong>Prescription medications:</strong> Mang đủ + dự phòng 30%
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-file-text-line text-purple-600 mt-1"></i>
                      <div>
                        <strong>Medical records:</strong> Tiếng Anh, recent tests
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-user-heart-line text-purple-600 mt-1"></i>
                      <div>
                        <strong>Doctor's letter:</strong> Chronic conditions
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-phone-line text-purple-600 mt-1"></i>
                      <div>
                        <strong>Emergency contacts:</strong> Doctor, family
                      </div>
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-purple-800 mb-4">🩺 Thiết bị y tế</h4>
                  <ul className="space-y-2 text-sm">
                    <li className="flex items-start gap-2">
                      <i className="ri-heart-pulse-line text-purple-600 mt-1"></i>
                      <div>
                        <strong>Medical devices:</strong> CPAP, blood pressure monitor
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-wheelchair-line text-purple-600 mt-1"></i>
                      <div>
                        <strong>Mobility aids:</strong> Walking stick, wheelchair
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-eye-line text-purple-600 mt-1"></i>
                      <div>
                        <strong>Vision/hearing:</strong> Extra glasses, hearing aids
                      </div>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-first-aid-kit-line text-purple-600 mt-1"></i>
                      <div>
                        <strong>First aid:</strong> Blood glucose, thermometer
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-8">
              <div className="bg-green-50 rounded-lg p-6">
                <h4 className="font-semibold text-green-900 mb-4 flex items-center gap-2">
                  <i className="ri-flight-land-line"></i>
                  Hỗ trợ tại sân bay
                </h4>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Wheelchair service:</strong> Yêu cầu khi book vé</li>
                  <li>• <strong>Priority boarding:</strong> Lên máy bay trước</li>
                  <li>• <strong>Aisle seat:</strong> Dễ di chuyển, vào toilet</li>
                  <li>• <strong>TSA PreCheck:</strong> Security nhanh hơn</li>
                  <li>• <strong>Airport escort:</strong> Staff hỗ trợ di chuyển</li>
                </ul>
              </div>
              
              <div className="bg-blue-50 rounded-lg p-6">
                <h4 className="font-semibold text-blue-900 mb-4 flex items-center gap-2">
                  <i className="ri-hotel-bed-line"></i>
                  Chọn chỗ ở phù hợp
                </h4>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Accessible rooms:</strong> ADA compliant</li>
                  <li>• <strong>Ground floor:</strong> Tránh cầu thang</li>
                  <li>• <strong>Near elevator:</strong> Gần thang máy</li>
                  <li>• <strong>Grab bars:</strong> Trong phòng tắm</li>
                  <li>• <strong>Medical facilities:</strong> Hospital nearby</li>
                </ul>
              </div>
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 mb-8">
              <h4 className="font-semibold text-yellow-800 mb-3">⚡ Lưu ý đặc biệt</h4>
              <div className="grid md:grid-cols-2 gap-4">
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Slow pace:</strong> Ít địa điểm, nhiều thời gian</li>
                  <li>• <strong>Rest breaks:</strong> Nghỉ mỗi 2-3 tiếng</li>
                  <li>• <strong>Comfortable shoes:</strong> Giày êm, chống trượt</li>
                  <li>• <strong>Weather consideration:</strong> Tránh thời tiết khắc nghiệt</li>
                </ul>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Medical insurance:</strong> Coverage comprehensive</li>
                  <li>• <strong>Emergency fund:</strong> $5,000+ cho y tế</li>
                  <li>• <strong>Flexible booking:</strong> Có thể cancel/change</li>
                  <li>• <strong>Travel companion:</strong> Không nên đi một mình</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Lập kế hoạch gia đình */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 flex items-center gap-3">
              <i className="ri-calendar-check-line text-teal-600"></i>
              Lập kế hoạch cho cả gia đình
            </h2>

            <div className="bg-gradient-to-r from-teal-50 to-cyan-50 rounded-xl p-8 mb-8">
              <h3 className="text-xl font-bold text-teal-900 mb-6">📅 Timeline chuẩn bị</h3>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="bg-white rounded-lg p-6">
                  <h4 className="font-bold text-teal-800 mb-4">3 tháng trước</h4>
                  <ul className="space-y-2 text-sm">
                    <li>✓ Book flights & accommodation</li>
                    <li>✓ Apply for passports/visas</li>
                    <li>✓ Medical check-up</li>
                    <li>✓ Travel insurance</li>
                    <li>✓ Research destinations</li>
                  </ul>
                </div>
                <div className="bg-white rounded-lg p-6">
                  <h4 className="font-bold text-teal-800 mb-4">1 tháng trước</h4>
                  <ul className="space-y-2 text-sm">
                    <li>✓ Confirm bookings</li>
                    <li>✓ Pack essentials</li>
                    <li>✓ Prepare documents</li>
                    <li>✓ Download apps</li>
                    <li>✓ Notify schools/work</li>
                  </ul>
                </div>
                <div className="bg-white rounded-lg p-6">
                  <h4 className="font-bold text-teal-800 mb-4">1 tuần trước</h4>
                  <ul className="space-y-2 text-sm">
                    <li>✓ Check-in online</li>
                    <li>✓ Final packing</li>
                    <li>✓ Currency exchange</li>
                    <li>✓ Charge devices</li>
                    <li>✓ Family meeting</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-pink-50 rounded-lg p-6">
                <h4 className="font-semibold text-pink-900 mb-4">👨‍👩‍👧‍👦 Hoạt động cho mọi lứa tuổi</h4>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Museums:</strong> Interactive exhibits</li>
                  <li>• <strong>Parks:</strong> Playgrounds + walking paths</li>
                  <li>• <strong>Tours:</strong> Family-friendly guides</li>
                  <li>• <strong>Shows:</strong> Age-appropriate entertainment</li>
                  <li>• <strong>Restaurants:</strong> Kids menu + highchairs</li>
                  <li>• <strong>Shopping:</strong> Malls with play areas</li>
                </ul>
              </div>
              
              <div className="bg-orange-50 rounded-lg p-6">
                <h4 className="font-semibold text-orange-900 mb-4">💰 Budget gia đình</h4>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Kids under 2:</strong> Miễn phí nhiều dịch vụ</li>
                  <li>• <strong>Family passes:</strong> Giảm giá nhóm</li>
                  <li>• <strong>Group rates:</strong> Hotels, tours</li>
                  <li>• <strong>Emergency fund:</strong> 20% budget</li>
                  <li>• <strong>Medical insurance:</strong> Cho tất cả thành viên</li>
                  <li>• <strong>Activity budget:</strong> $100-200/person/day</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Emergency planning */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 flex items-center gap-3">
              <i className="ri-alarm-warning-line text-red-600"></i>
              Kế hoạch khẩn cấp
            </h2>

            <div className="bg-red-50 border border-red-200 rounded-xl p-8">
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h4 className="font-semibold text-red-800 mb-4">🆘 Danh sách liên lạc khẩn cấp</h4>
                  <ul className="space-y-2 text-sm">
                    <li>• <strong>911:</strong> Emergency services</li>
                    <li>• <strong>Consulate VN:</strong> Embassy contact</li>
                    <li>• <strong>Hotel front desk:</strong> 24/7 support</li>
                    <li>• <strong>Travel insurance:</strong> Claim hotline</li>
                    <li>• <strong>Family doctor:</strong> Medical consultation</li>
                    <li>• <strong>Bank:</strong> Card lost/stolen</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-red-800 mb-4">📱 Ứng dụng quan trọng</h4>
                  <ul className="space-y-2 text-sm">
                    <li>• <strong>Find My:</strong> Location tracking</li>
                    <li>• <strong>Google Translate:</strong> Communication</li>
                    <li>• <strong>First Aid by Red Cross:</strong> Medical guide</li>
                    <li>• <strong>What3Words:</strong> Precise location</li>
                    <li>• <strong>TravelSafe:</strong> Country safety info</li>
                    <li>• <strong>Smart Traveler:</strong> State Dept alerts</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Success tips */}
          <section className="mb-12">
            <div className="bg-gradient-to-r from-green-500 to-teal-500 rounded-xl p-8 text-white">
              <h2 className="text-2xl font-bold mb-6 text-center">🌟 Bí quyết thành công</h2>
              <div className="grid md:grid-cols-3 gap-6">
                <div>
                  <h3 className="font-semibold mb-4 text-green-100">Trước chuyến đi:</h3>
                  <ul className="space-y-2 text-sm text-green-100">
                    <li>• Họp gia đình thảo luận</li>
                    <li>• Phân công trách nhiệm</li>
                    <li>• Practice packing</li>
                    <li>• Set expectations</li>
                    <li>• Emergency drill</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold mb-4 text-green-100">Trong chuyến đi:</h3>
                  <ul className="space-y-2 text-sm text-green-100">
                    <li>• Stay flexible</li>
                    <li>• Take breaks frequently</li>
                    <li>• Document memories</li>
                    <li>• Stay connected</li>
                    <li>• Enjoy the moment</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold mb-4 text-green-100">Sau chuyến đi:</h3>
                  <ul className="space-y-2 text-sm text-green-100">
                    <li>• Share experiences</li>
                    <li>• Create photo album</li>
                    <li>• Plan next trip</li>
                    <li>• Thank travel companions</li>
                    <li>• Learn from experience</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* CTA */}
          <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl p-8 text-white text-center">
            <h3 className="text-2xl font-bold mb-4">Cần hỗ trợ lập kế hoạch gia đình?</h3>
            <p className="mb-6 text-purple-100">
              Chúng tôi có kinh nghiệm tư vấn du lịch gia đình nhiều thế hệ!
            </p>
            <div className="flex flex-col gap-3 max-w-md mx-auto">
              <button className="bg-white text-purple-600 px-8 py-3 rounded-lg text-lg font-semibold hover:bg-purple-50 transition-colors whitespace-nowrap cursor-pointer">
                Tư vấn du lịch gia đình
              </button>
              <button className="bg-purple-700 hover:bg-purple-800 text-white px-8 py-3 rounded-lg text-lg font-semibold border-2 border-white transition-colors whitespace-nowrap cursor-pointer">
                Checklist gia đình chi tiết
              </button>
            </div>
          </div>
        </article>
      </div>

      <Footer />
    </div>
  );
}
